const getGroupOptions = options => options.filter(option => !!option.type)
const getLabel = item => item.text
const getValueLabel = ({ id: value, text: label }) => ({ value, label })
const setOptions = (options, data, getOption) => {
  options[0].items = data[0].frequent.list.map(getOption)
  options[1].items = data[1].other.list.map(getOption)
  return options
}

const frequentAndAllDropDownOptions = () => [
  {
    type: 'group',
    name: 'Frequently Used',
    items: [],
  },
  {
    type: 'group',
    name: 'All',
    items: [],
  },
]

const groupOptions = () => getGroupOptions(frequentAndAllDropDownOptions())
const getCountryDropdownOptions = data =>
  setOptions(groupOptions(), data, getValueLabel)
const getMotherTongueDropdownOptions = data =>
  setOptions(groupOptions(), data, getLabel)
const getPostedByDropdownOptions = data => data.map(getLabel)

export {
  getCountryDropdownOptions,
  getMotherTongueDropdownOptions,
  getPostedByDropdownOptions,
}
